import { render, staticRenderFns } from "./async-script.vue?vue&type=template&id=7b870880"
import script from "./async-script.vue?vue&type=script&lang=js"
export * from "./async-script.vue?vue&type=script&lang=js"
import style0 from "./async-script.vue?vue&type=style&index=0&id=7b870880&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports